import Vue from 'vue'
import Vuex from 'vuex'
import { groupBy } from 'lodash'
import { APP_BUNDLES, APP_BOTTOM_NAV_LOCKED, APP_OPEN_BUNDLES, APP_DATES, APP_USER, APP_VERSION, APP_REPORTED, APP_DELIVERY_DATES, APP_LAST_SELECTED_BUNDLE_ID, APP_MODE, APP_PAPERS, APP_ALERTS_SHOWN, APP_IMPERSONATED_ID} from '@/store/appStates'
import { SET_USER,SET_APP_MODE ,LOCK_BOTTOM_NAV, UNLOCK_BOTTOM_NAV, SET_OPEN_BUNDLES, SET_PAPERS, SET_REPORTED, SET_DELIVERY, UPDATE_DELIVERY, ADD_REPORTED, SET_LAST_SELECTED_BUNDLE_ID, REMOVE_LAST_SELECTED_BUNDLE_ID, SET_ALERTS_SHOWN, RESET_CUSTOMER_STATE, SET_IMPERSONATED_ID} from '@/store/appMutations'
import * as pt from '@/model/paperTypes'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)


export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    [APP_VERSION]: '1.1.2',
    [APP_USER]: {},
    [APP_BUNDLES]: [],
    [APP_OPEN_BUNDLES]: {
      [pt.NEWSPAPER]: [],
      [pt.INSERT]: []
    },
    [APP_DATES]: {            // Grupperade huvudtidningar
      [pt.NEWSPAPER]: {},
      [pt.INSERT]: {}
    },
    [APP_PAPERS]:{
      [pt.NEWSPAPER]: {},
      [pt.INSERT]: {}
    },
    [APP_REPORTED]: [],       // Rapporterade
    [APP_DELIVERY_DATES]: [],
    [APP_BOTTOM_NAV_LOCKED]: true,
    [APP_LAST_SELECTED_BUNDLE_ID]: {            // Senast använda bunt id
      [pt.NEWSPAPER]: {},
      [pt.INSERT]: {}
    },
    [APP_MODE]:'web',
    [APP_ALERTS_SHOWN]:false,
    [APP_IMPERSONATED_ID]: undefined
    
  },
  getters:{
    user:state=>{
      return state[APP_USER]
    }
  },
  mutations: {
    [SET_USER](state, payload) {
      state[APP_USER] = payload
    },
    [SET_APP_MODE](state, payload){
      state[APP_MODE] = payload
    },
    [LOCK_BOTTOM_NAV](state) {
      state[APP_BOTTOM_NAV_LOCKED] = true
    },
    [UNLOCK_BOTTOM_NAV](state) {
      state[APP_BOTTOM_NAV_LOCKED] = false
    },
    [SET_OPEN_BUNDLES](state, payload) {
      var paperType = payload.paperType
      var bundles = payload.bundles
      state[APP_OPEN_BUNDLES][paperType] = bundles    
      if(bundles.length >0 ) {
        state[APP_LAST_SELECTED_BUNDLE_ID][paperType] = bundles[0].id
      }
    },
    [SET_PAPERS](state, payload) {
      var paperType = payload.paperType
      var papers = payload.papers
      state[APP_DATES][paperType] = groupBy(papers, p => p.deliveryDate)
      state[APP_PAPERS][paperType] = papers
    },
    [SET_REPORTED](state, payload) {
      state[APP_REPORTED] = payload
    },
    [SET_DELIVERY](state, payload) {
      // state[APP_DELIVERY_DATES] = flow(
      //     groupBy(p => p.deliveryDate)
      //     //map((k, v) => ({ key: k, value: v })),
      //     //tap(console.log)
      //   )(payload)
      state[APP_DELIVERY_DATES] = groupBy(payload, p => p.deliveryDate)     
      //state[APP_DELIVERY_DATES] = payload // payload.reduce((r, v, i, a, k = v.length) => ((r[k] || (r[k] = [])).push(v), r), {})
      //Object.keys(dates)
      console.log('Delivery dates:', state[APP_DELIVERY_DATES])
      //state[APP_DELIVERY_DATES][0].active = true
    },
    [UPDATE_DELIVERY](state, payload) {
      const index = state[APP_DELIVERY_DATES][payload.deliveryDate].findIndex(p => p.id === payload.id)
      if (index > -1) {
        state[APP_DELIVERY_DATES][payload.deliveryDate].splice(index, 1, payload)
      }
    },
    [ADD_REPORTED](state, payload) {
      const index = state[APP_REPORTED].findIndex(p => p.id === payload.id)
      if (index > -1) {
        state[APP_REPORTED].splice(index, 1, payload)
      } else {
        state[APP_REPORTED].push(payload)
      }
    },
    [SET_LAST_SELECTED_BUNDLE_ID](state,payload){
      var paperType = payload.paperType
      var bundleId = payload.bundleId
      state[APP_LAST_SELECTED_BUNDLE_ID][paperType] = bundleId
    },
    [REMOVE_LAST_SELECTED_BUNDLE_ID](state,payload){      
      if(payload === undefined){
        state[APP_LAST_SELECTED_BUNDLE_ID][0] = undefined
        state[APP_LAST_SELECTED_BUNDLE_ID][1] = undefined
      }else{
        var bundleId = payload.bundleId
        
        if(state[APP_LAST_SELECTED_BUNDLE_ID][0] === bundleId){
          state[APP_LAST_SELECTED_BUNDLE_ID][0] = undefined
        }
        else if (state[APP_LAST_SELECTED_BUNDLE_ID][1] === bundleId) {
          state[APP_LAST_SELECTED_BUNDLE_ID][1] = undefined
        }
      }
      
    },
    [SET_ALERTS_SHOWN](state, payload) {
      state[APP_ALERTS_SHOWN] = payload
    },
    [SET_IMPERSONATED_ID](state, payload) {
      state[APP_IMPERSONATED_ID] = payload
    },
    [RESET_CUSTOMER_STATE](state) {
      state[APP_OPEN_BUNDLES] = { [pt.NEWSPAPER]: [], [pt.INSERT]: [] }
      state[APP_DATES] = { [pt.NEWSPAPER]: {}, [pt.INSERT]: {} }
      state[APP_PAPERS] = { [pt.NEWSPAPER]: {}, [pt.INSERT]: {} }
      state[APP_REPORTED] = []
      state[APP_DELIVERY_DATES] = []
      state[APP_LAST_SELECTED_BUNDLE_ID] = { [pt.NEWSPAPER]: {}, [pt.INSERT]: {} }
      state[APP_ALERTS_SHOWN] = false
    },
  },
})
